// SEM URL Number for Step 3 [Badge string, TooltipContentType TooltipContentType, TooltipType string]
import { TooltipContentType } from 'component/Incentive/Badge/__config/TooltipContentType';

const badgeType: Record<number, [string, TooltipContentType?, string?]> = {
    1: ['early-bird-50', TooltipContentType.EARLY_BIRD, 'discount'],
    2: ['last-minute-50', TooltipContentType.LAST_MINUTE, 'discount'],
    3: ['last-minute-50', TooltipContentType.LAST_MINUTE, 'discount'],
    4: ['best-in-test-2', TooltipContentType.BEST_IN_TEST, 'text'],
    5: ['tuev-service', TooltipContentType.TUEV_SERVICE, 'text'],
    //6: ['best-in-test-3', TooltipContentType.BEST_IN_TEST, 'text'],
    //6: ['early-bird-50', TooltipContentType.EARLY_BIRD, 'discount'],
    6: ['last-minute-50', TooltipContentType.LAST_MINUTE, 'discount'],
    //6: ['discount-50', TooltipContentType.DISCOUNT, 'discount'],
    7: ['touroperator'],
    8: ['save-70'],
    9: ['early-bird-30', TooltipContentType.EARLY_BIRD, 'discount'],
    10: [
        'best-price-guarantee-2',
        TooltipContentType.BEST_PRICE_GUARANTEE,
        'text',
    ],
    11: ['known-from-tv'],
    12: ['last-minute-40', TooltipContentType.LAST_MINUTE, 'discount'],
    13: ['best-deal-offer'],
    14: [
        'best-price-guarantee-1',
        TooltipContentType.BEST_PRICE_GUARANTEE,
        'text',
    ],
    15: ['best-in-test-3', TooltipContentType.BEST_IN_TEST, 'text'],
    16: ['last-minute-50', TooltipContentType.LAST_MINUTE, 'discount'],
    17: ['best-in-test-4', TooltipContentType.BEST_IN_TEST, 'text'],
    19: ['discount-50', TooltipContentType.DISCOUNT, 'discount'],
    20: ['cancellation', TooltipContentType.CANCELLATION, 'text'],
};

export function getBadgeType(badgeNumber: number) {
    return badgeType[badgeNumber] || false;
}
